export default {
    state: {
        referenceValue: null,
        difference: 0,
        priceFrom: undefined,
        priceTo: undefined,
        roundingOptions: [],
        roundingType: null
    },
    mutations: {
        setPriceFrom(state, priceFrom) {
            state.priceFrom = priceFrom;
        },
        setPriceTo(state, priceTo) {
            state.priceTo = priceTo;
        },
        setRoundingOptions(state, roundingOptions) {
            state.roundingOptions = roundingOptions;
        },
        setRoundingType(state, roundingType) {
            state.roundingType = roundingType;
        },
        setReferenceValue(state, referenceValue) {
            state.referenceValue = referenceValue;
        },
        setDifference(state, difference) {
            state.difference = difference;
        }
    }
};
